import { gql } from "@apollo/client";

export const GET_HONORARIOS = gql`
query allHonorariosProfesional(
    $where: t_HonorarioProfesionalFilterInput  
) {
    allHonorariosProfesional(where: $where )
    {
        idHonorarioProfesional
        idDelegacion
        descripcion
        idTipoProfesional
        idFiguraProfesionalNavigation{
            descripcion
        }
        idClaseMonitoreoNavigation{
            descripcion
        }
        idFormaLiquidacionNavigation{
            descripcion
        }
        idTipoProfesionalNavigation{
            descripcion
        }
        t_HonorarioProfesional_TipoModulo{
            idTipoModuloNavigation{
                abreviacion
            }
        }
        valor
        valorVirtual
        activo
        fechaExpira
    }
}`;

export const adaptHonorario = (honorario) => {
  return {
    id: honorario?.idHonorarioProfesional,
    idDelegacion: honorario?.idDelegacion,
    descripcion: honorario?.descripcion,
    idTipoProfesional: honorario?.idTipoProfesional,
    figuraProfesional: honorario?.idFiguraProfesionalNavigation?.descripcion,
    clasificacionMonitoreo: honorario?.idClaseMonitoreoNavigation?.descripcion,
    formaLiquidacion: honorario?.idFormaLiquidacionNavigation?.descripcion,
    tipoProfesional: honorario?.idTipoProfesionalNavigation?.descripcion,
    valorPresencial: honorario?.valor,
    valorVirtual: honorario?.valorVirtual,
    activo: honorario?.activo,
    abreviaciones: honorario.t_HonorarioProfesional_TipoModulo.
    map((modulo) => modulo.idTipoModuloNavigation.abreviacion).
    join(', '),
    fechaExpira: honorario?.fechaExpira
  };
};

const adaptHonorariosArray = (honorariosData) => {

  return structuredClone(honorariosData?.allHonorariosProfesional)?.
  map((honorario) => adaptHonorario(honorario)) || [];
};

export default adaptHonorariosArray;

export const adaptHonorariosParsedArray = (honorariosData) => {
  return structuredClone(honorariosData)?.
  map((honorario) => adaptHonorario(honorario)) || [];
};